import { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { Colors } from "../../../constants/styles";
import { Loader, SearchBar } from "../../../components";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Alert,
  Button,
  Snackbar,
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Autocomplete,
  TextField,
  Paper,
} from "@mui/material";
import DatePicker from "react-datepicker";
import { makeStyles } from "@mui/styles";
import SaveIcon from "@mui/icons-material/Save";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { NumericFormat } from "react-number-format";
import useScreenWidth from "../../../hooks/useScreenWidth";

const useStyles = makeStyles({
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      backgroundColor: Colors.blue700,
    },
  },
  tableRightBorder: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
});

const toIsoDate = (value) => {
  if (!value) return "";
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return `${value.getFullYear()}-${String(value.getMonth() + 1).padStart(2, "0")}-${String(value.getDate()).padStart(2, "0")}`;
  }
  const valueText = String(value).trim();
  const indonesiaDate = valueText.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (indonesiaDate) {
    const [, day, month, year] = indonesiaDate;
    return `${year}-${month}-${day}`;
  }
  const isoDate = valueText.match(/^(\d{4}-\d{2}-\d{2})/);
  return isoDate ? isoDate[1] : "";
};

const TambahHasilStockOpname = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [noBukti, setNoBukti] = useState("");
  const [inputTglHasilStockOpname, setInputTglHasilStockOpname] = useState(
    new Date(user.tutupperiode.dariTanggal),
  );
  const [kodeCOA, setKodeCOA] = useState("");

  // Data Child
  const [reloadListHasilStockOpnameChild, setReloadListHasilStockOpnameChild] =
    useState(0);
  const [stokPerCabangsData, setStokPerCabangsData] = useState([]);
  const [listHasilStockOpnameChild, setListHasilStockOpnameChild] = useState([
    {
      stokId: "",
      quantityLama: 0,
      quantityBaru: "",
      quantitySelisih: 0,
    },
  ]);

  const [openCOA, setOpenCOA] = useState(false);
  const [searchTermCOA, setSearchTermCOA] = useState("");
  const [error, setError] = useState(false);
  const [COAsData, setCOAsData] = useState([]);
  const [COAsBankData, setCOAsBankData] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const classes = useStyles();

  const handleClickOpenCOA = () => {
    setOpenCOA(true);
  };

  const handleCloseCOA = () => {
    setOpenCOA(false);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const tempPostsCOA = COAsBankData.filter((val) => {
    if (searchTermCOA === "") {
      return val;
    } else if (
      val.kodeCOA.toUpperCase().includes(searchTermCOA.toUpperCase()) ||
      val.namaCOA.toUpperCase().includes(searchTermCOA.toUpperCase())
    ) {
      return val;
    }
  });

  useEffect(() => {
    findDefaultDate();
    getCOAsData();
    getCOAsBankData();
  }, []);

  useEffect(() => {
    if (!inputTglHasilStockOpname) return;
    getNextKodeHasilStockOpname();
    getStokPerCabangsData();
  }, [inputTglHasilStockOpname]);

  const findDefaultDate = async () => {
    let newPeriodeAwal = new Date(user.tutupperiode.dariTanggal);
    let newPeriodeAkhir = new Date(user.tutupperiode.sampaiTanggal);
    let newToday = new Date();

    let isDateBetween =
      newToday >= newPeriodeAwal && newToday <= newPeriodeAkhir;

    if (isDateBetween) {
      // Default Date Today
      setInputTglHasilStockOpname(new Date());
    }
  };

  const getNextKodeHasilStockOpname = async () => {
    setLoading(true);
    const nextKodeHasilStockOpname = await axios.post(
      `${tempUrl}/hasilStockOpnamesNextKode`,
      {
        dariTanggal: user.tutupperiode.dariTanggal,
        sampaiTanggal: user.tutupperiode.sampaiTanggal,
        tglHasilStockOpname: toIsoDate(inputTglHasilStockOpname),
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      },
    );
    setNoBukti(nextKodeHasilStockOpname.data);
    setLoading(false);
  };

  const getCOAsData = async () => {
    setLoading(true);
    const allCOAs = await axios.post(`${tempUrl}/COAs`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setCOAsData(allCOAs.data);
    setLoading(false);
  };

  const getCOAsBankData = async () => {
    setLoading(true);
    const allCOAs = await axios.post(`${tempUrl}/COAs`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setCOAsBankData(allCOAs.data);
    setLoading(false);
  };

  const getStokPerCabangsData = async () => {
    setLoading(true);
    const allStokPerCabangs = await axios.post(
      `${tempUrl}/stokPerCabangsHasilStockOpname`,
      {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
        tglHasilStockOpname: toIsoDate(inputTglHasilStockOpname),
      },
    );
    setStokPerCabangsData(allStokPerCabangs.data);
    setLoading(false);
  };

  const saveHasilStockOpname = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (
      form.checkValidity() &&
      kodeCOA.length !== 0 &&
      listHasilStockOpnameChild.some((item) => item.stokId)
    ) {
      setLoading(true);
      try {
        setLoading(true);
        let tempCOA = await axios.post(`${tempUrl}/COAByKode`, {
          kodeCOA,
          kodeCabang: user.cabang.id,
          _id: user.id,
          token: user.token,
        });
        const childrenToSave = listHasilStockOpnameChild
          .filter((item) => item.stokId)
          .map((item) => ({
            ...item,
            quantityBaru:
              item.quantityBaru === ""
                ? 0
                : Number(item.quantityBaru) || 0,
          }));
        await axios.post(`${tempUrl}/saveHasilStockOpname`, {
          dariTanggal: user.tutupperiode.dariTanggal,
          sampaiTanggal: user.tutupperiode.sampaiTanggal,
          tglHasilStockOpname: toIsoDate(inputTglHasilStockOpname),
          coaId: tempCOA.data.id,
          listHasilStockOpnameChild: childrenToSave,

          userIdInput: user.id,
          kodeCabang: user.cabang.id,
          _id: user.id,
          token: user.token,
        });
        setLoading(false);
        navigate("/daftarHasilStockOpname");
      } catch (error) {
        alert(error.response.data.message);
      }
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Transaksi</h3>
      <h5 style={{ fontWeight: 400 }}>Tambah Hasil Stock Opname</h5>
      <Typography sx={subTitleText}>
        Periode : {user.tutupperiode.namaPeriode}
      </Typography>
      <hr />
      <Form noValidate validated={validated} onSubmit={saveHasilStockOpname}>
        <Card>
          <Card.Header>Hasil Stock Opname</Card.Header>
          <Card.Body>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    No. Bukti :
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control required value={noBukti} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Tanggal <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="9">
                    <DatePicker
                      required
                      dateFormat="dd/MM/yyyy"
                      selected={inputTglHasilStockOpname}
                      minDate={new Date(user.tutupperiode.dariTanggal)}
                      maxDate={new Date(user.tutupperiode.sampaiTanggal)}
                      customInput={<Form.Control required />}
                      onChange={(date) => setInputTglHasilStockOpname(date)}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="3" style={textRight}>
                    Kode COA <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="9">
                    <Form.Control
                      required
                      value={kodeCOA}
                      readOnly
                      placeholder="Pilih..."
                      onClick={() => handleClickOpenCOA()}
                      isInvalid={kodeCOA.length === 0 && true}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
        <Card style={{ marginTop: 10 }}>
          <Card.Header>Detail Stok</Card.Header>
          <Card.Body>
            <Box sx={spacingTop}>
              <Button
                variant="contained"
                color="info"
                sx={{
                  bgcolor: "info.light",
                  textTransform: "none",
                  marginRight: 2,
                  marginBottom: 2,
                }}
                onClick={() => {
                  listHasilStockOpnameChild.push({
                    stokId: "",
                    quantityLama: 0,
                    quantityBaru: "",
                    quantitySelisih: 0,
                  });
                  setReloadListHasilStockOpnameChild(
                    Math.floor(Math.random() * 1000),
                  );
                }}
              >
                {"+ Input Stok"}
              </Button>
            </Box>
            <TableContainer component={Paper} sx={{ width: "100%" }}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Stok
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Quantity Sistem
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Hasil SO
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Quantity Selisih
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Hapus
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {listHasilStockOpnameChild.map(
                    (hasilStockOpnameChild, index) => (
                      <TableRow key={index}>
                        <TableCell component="th" scope="row">
                          <Autocomplete
                            size="small"
                            disablePortal
                            options={stokPerCabangsData}
                            getOptionLabel={(option) =>
                              option.stok
                                ? `${option.stok.kodeStok} - ${option.stok.namaStok}`
                                : ""
                            }
                            isOptionEqualToValue={(option, value) =>
                              String(option.stokId) === String(value.stokId)
                            }
                            value={
                              stokPerCabangsData.find(
                                (item) =>
                                  String(item.stokId) ===
                                  String(hasilStockOpnameChild.stokId),
                              ) || null
                            }
                            renderInput={(params) => (
                              <TextField
                                size="small"
                                sx={{ width: "300px" }}
                                placeholder="Cari stok..."
                                {...params}
                              />
                            )}
                            onChange={(e, value) => {
                              const quantityLama = Number(
                                value?.quantityStok || 0,
                              );
                              hasilStockOpnameChild.stokId =
                                value?.stokId || "";
                              hasilStockOpnameChild.quantityLama = quantityLama;
                              hasilStockOpnameChild.quantitySelisih =
                                quantityLama -
                                Number(hasilStockOpnameChild.quantityBaru || 0);
                              setReloadListHasilStockOpnameChild(
                                Math.floor(Math.random() * 1000),
                              );
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          <NumericFormat
                            value={hasilStockOpnameChild.quantityLama}
                            decimalSeparator={","}
                            thousandSeparator={"."}
                            customInput={Form.Control}
                            disabled
                          />
                        </TableCell>
                        <TableCell align="right">
                          <NumericFormat
                            value={hasilStockOpnameChild.quantityBaru}
                            decimalSeparator={","}
                            thousandSeparator={"."}
                            customInput={Form.Control}
                            onValueChange={(values) => {
                              const quantityBaru =
                                values.value === ""
                                  ? ""
                                  : values.floatValue || 0;
                              hasilStockOpnameChild.quantityBaru = quantityBaru;
                              hasilStockOpnameChild.quantitySelisih =
                                Number(
                                  hasilStockOpnameChild.quantityLama || 0,
                                ) - Number(quantityBaru || 0);
                              setReloadListHasilStockOpnameChild(
                                Math.floor(Math.random() * 1000),
                              );
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          <NumericFormat
                            value={hasilStockOpnameChild.quantitySelisih}
                            decimalSeparator={","}
                            thousandSeparator={"."}
                            customInput={Form.Control}
                            disabled
                          />
                        </TableCell>
                        <TableCell>
                          <Button
                            variant="contained"
                            color="error"
                            sx={{ textTransform: "none" }}
                            onClick={() => {
                              listHasilStockOpnameChild.splice(index, 1);
                              setReloadListHasilStockOpnameChild(
                                Math.floor(Math.random() * 1000),
                              );
                            }}
                          >
                            <DeleteOutlineIcon />
                          </Button>
                        </TableCell>
                      </TableRow>
                    ),
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Card.Body>
        </Card>
        <Box sx={spacingTop}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => navigate("/daftarHasilStockOpname")}
            sx={{ marginRight: 2 }}
          >
            {"< Kembali"}
          </Button>
          <Button variant="contained" startIcon={<SaveIcon />} type="submit">
            Simpan
          </Button>
        </Box>
      </Form>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
      <Dialog
        open={openCOA}
        onClose={handleCloseCOA}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data COA`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <SearchBar setSearchTerm={setSearchTermCOA} />
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Kode COA
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Nama
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tempPostsCOA
                    .filter((val) => {
                      if (searchTermCOA === "") {
                        return val;
                      } else if (
                        val.kodeCOA
                          .toUpperCase()
                          .includes(searchTermCOA.toUpperCase()) ||
                        val.namaCOA
                          .toUpperCase()
                          .includes(searchTermCOA.toUpperCase())
                      ) {
                        return val;
                      }
                    })
                    .map((user, index) => (
                      <TableRow
                        key={user._id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                          "&:hover": { bgcolor: Colors.grey300 },
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setKodeCOA(user.kodeCOA);
                          handleCloseCOA();
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {user.kodeCOA}
                        </TableCell>
                        <TableCell>{user.namaCOA}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default TambahHasilStockOpname;

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const subTitleText = {
  fontWeight: "900",
};

const dialogContainer = {
  display: "flex",
  flexDirection: "column",
  width: "800px",
};

const dialogWrapper = {
  width: "100%",
  marginTop: 2,
};

const colorRed = {
  color: "red",
};
